import { useEffect } from "react";
import privacyMd from "../content/policies/privacy.md?raw";
import { renderMarkdown } from "../lib/markdown";
import { EditorialPage } from "../components/editorial";
import Navbar from "../components/Navbar";
import StoryPageHero from "../components/story/StoryPageHero";

// (e.g. PR #97's v2.0 -> v2.1) can never leave a stale hardcoded header here.

export default function PrivacyPage() {
  useEffect(() => {
    document.title = "Privacy Policy | LetsLoop";
  }, []);

  return (
    <>
      <Navbar />
      <EditorialPage>
        {/* Header band only. The policy body deliberately keeps its plain
            styling: these pages are read for meaning under pressure, and
            decorating running legal text makes it harder, not better. One
            doodle, no colour grounds, no marker slabs. */}
        <StoryPageHero
          kicker="privacy"
          title={<>Your data, and what we do not do with it.</>}
          marks={[
            {
              name: "loop",
              size: 58,
              rotate: 8,
              className: "right-[8%] top-[30%] text-teal/25",
            },
          ]}
        />

        <article className="relative max-w-3xl mx-auto px-4 md:px-6 pt-4 pb-16 md:pb-24">
          {renderMarkdown(privacyMd)}
        </article>
      </EditorialPage>
    </>
  );
}
